import styled from 'styled-components';

export const MirroredIcon = styled.span`
	& > svg {
		transform: rotate(180deg);
	}
`;
